export const minmax = (min: number, max: number, value: number) =>
  Math.min(Math.max(min, value), max);

export const randBetween = (min: number, max: number) =>
  Math.floor(Math.random() * (max - min + 1) + min);
